import { graphql } from "react-relay";

export const EditPolicyCollectionMutation = graphql`
  mutation EditPolicyCollectionMutation(
    $input: UpdatePolicyCollectionInput!
    $updateMappingsInput: UpsertPolicyCollectionMappingsInput!
    $removeMappingsInput: RemovePolicyCollectionMappingsInput!
    $connections: [ID!]!
  ) {
    removePolicyCollectionMappings(input: $removeMappingsInput) {
      removed {
        id @deleteRecord
      }
    }
    updatePolicyCollection(input: $input) {
      collection {
        autoUpdate
        description
        id
        name
        repositoryView {
          branchName
          id
          policyDirectories
          policyFileSuffix
          uuid
        }
        uuid
      }
    }
    upsertPolicyCollectionMappings(input: $updateMappingsInput) {
      mappings
        @appendNode(
          connections: $connections
          edgeTypeName: "PolicyCollectionMappingEdge"
        ) {
        policy {
          id
          name
        }
      }
    }
  }
`;
